require("./bootstrap");

import {Modal} from './Modal.js';
import { ModalOrNotificationList } from "./ModalOrNotificationList";
import { NotificationList } from "./NotificationList";

(function (window) {

    const Ticketing = window.Ticketing || (window.Ticketing = {});

    Ticketing.modal = {
        open: (el) => Modal.open(el),
        close: (el) => Modal.close(el),
    };

    Ticketing.notificationList = {
        open: (el) => NotificationList.open(el),
        close: (el) => NotificationList.close(el),
    };

    ModalOrNotificationList.init();

})(window);
